import { NgxMatDatetimePickerModule } from '@angular-material-components/datetime-picker';
import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslationModule } from '@lib/translation';
import { SnFormModule } from 'libs/form/src/lib/form.module';
import { SnIconModule } from 'libs/ui/icon/src/lib/icon.module';

import { CustomDateRangeDialogComponent } from './components/custom-date-range-dialog/custom-date-range-dialog.component';
import { FsDateRangePickerV2FormField } from './components/date-range-picker-v2/date-range-picker-v2.form-field';
import { FsDateRangePickerFormField } from './components/date-range-picker/date-range-picker.form-field';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatDatepickerModule,
    MatMenuModule,
    MatSelectModule,
    MatTooltipModule,
    NgxMatDatetimePickerModule,
    SnFormModule,
    SnIconModule,
    TranslationModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'date-range-picker',
          component: FsDateRangePickerFormField,
          wrappers: ['form-field'],
        },
        {
          name: 'date-range-picker-v2',
          component: FsDateRangePickerV2FormField,
          wrappers: ['form-field'],
        },
      ],
    }),
  ],
  exports: [FsDateRangePickerFormField, FsDateRangePickerV2FormField],
  declarations: [
    FsDateRangePickerFormField,
    CustomDateRangeDialogComponent,
    FsDateRangePickerV2FormField,
  ],
})
export class DateRangePickerModule {}
